import React from 'react';
import { ErrorMessage, Label, Skeleton } from '../index';
import cx from 'clsx';
import { useSelector } from 'react-redux';
import { defaultCountries, parseCountry, PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import styles from './index.module.scss';
import { TENANT_ELEMENTS } from '@constants/generic-constants';
import { isOLXTenant } from '../../../utils/utils';
import { ShowPhoneButton } from '@common-web/show-phone-button';

const PhoneNumberInput = ({
  value = '',
  onChange = () => {},
  label = '',
  labelClassName = '',
  labelSize,
  containerClassName,
  errorMsg = '',
  required = false,
  loading = false,
  disabled = false,
  hideFlag = false,
  labelSuffix = null,
  sellerId,
  jarvisClientId
}) => {
  if (loading) return <Skeleton height={40} />;
  const tenant = useSelector((state) => state?.tenantData?.tenant);
  const tenantObj = TENANT_ELEMENTS?.[tenant?.name ?? (isOLXTenant() ? 'OLX-PK' : 'DUBIZZLE-UAE')];
  const prefix = tenant?.country_code ?? tenantObj?.prefix;
  const placeholder = tenantObj?.phone_placeholder;
  const tld = tenantObj?.tld;

  const countries = defaultCountries
    .filter((country) => {
      const { iso2 } = parseCountry(country);
      return iso2 === tld;
    })
    ?.map((country) => {
      const formattedCountry = [...country];
      const format = formattedCountry.pop();
      formattedCountry.push(format?.replace('-', ' '));
      return formattedCountry;
    });

  return (
    !!countries?.length && (
      <div className={cx(containerClassName)}>
        {label && (
          <Label size={labelSize} className={labelClassName} required={required}>
            {label}
          </Label>
        )}
        {!!jarvisClientId ? (
          <div style={{ marginTop: 5 }}>
            <ShowPhoneButton storeId={sellerId} />
          </div>
        ) : (
          <div style={{ position: 'relative' }}>
            <PhoneInput
              countries={countries}
              hideDropdown={true}
              disabled={disabled}
              defaultCountry={tld}
              value={value}
              onChange={(phone) => {
                if (prefix && phone !== prefix) {
                  onChange(phone);
                } else onChange('');
              }}
              placeholder={`${prefix} ${placeholder}`}
              disableCountryGuess
              className={cx(
                'oms ant-input-css-var',
                styles.phoneInput,
                hideFlag && styles.phoneInputHide,
                errorMsg && styles.phoneInputError
              )}
              countrySelectorStyleProps={{
                buttonStyle: {
                  display: hideFlag ? 'none' : 'flex',
                },
              }}
            />
            <div style={{ position: 'absolute', insetInlineEnd: 10, insetBlockStart: 8 }}>{labelSuffix}</div>
          </div>
        )}
        <ErrorMessage errorMsg={errorMsg} />
      </div>
    )
  );
};

export default PhoneNumberInput;
